import { v4 as uuid } from 'uuid';
import { FormIdStateAction, Reducer, FormIdState, formIdStateActions, ReducerActions } from '@/context/types';

const makeFormIdInitialState = (): FormIdState => ({ value: '' });

const reducerActions: ReducerActions<FormIdState, FormIdStateAction> = (state) => ({
  form_id_create: () => ({ ...state, value: uuid() }),
});

export const formIdReducer: Reducer<FormIdState, FormIdStateAction> = (state, { action }) =>
  formIdStateActions.includes(action) ? reducerActions(state)[action]() : { ...state };

formIdReducer.key = 'formId';
formIdReducer.initialState = makeFormIdInitialState();
